import { computed, inject, Injectable } from '@angular/core';
import {
  VERTICAL_SCROLL_OFFSET_DESKTOP,
  VERTICAL_SCROLL_OFFSET_MOBILE,
} from '@core/config-angular';
import { MediaObserverService } from '@innogy/shared/responsive-tools';
import { PlatformService } from '@core/platform';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  readonly #mediaObserverService = inject(MediaObserverService);
  readonly #platformService = inject(PlatformService);
  readonly #offsetDesktop = inject(VERTICAL_SCROLL_OFFSET_DESKTOP, {
    optional: true,
  });
  readonly #offsetMobile = inject(VERTICAL_SCROLL_OFFSET_MOBILE, {
    optional: true,
  });

  public readonly verticalScrollOffset = computed(() => {
    const { isDesktop } = this.#mediaObserverService.deviceInfo();
    return (isDesktop ? this.#offsetDesktop : this.#offsetMobile) ?? 0;
  });

  getElementVerticalOffset(
    element: HTMLElement | null | undefined
  ): number | undefined {
    if (this.#platformService.isClient()) {
      return element?.getBoundingClientRect?.()?.top;
    }
    return undefined;
  }
}
